import * as api from '../prospectsApi';
import {
  ActivateProspect,
  IProspectApiResponse,
  prospectActionCreators,
  ProspectsActionKeys
  } from '..';
import { call, put, takeEvery } from 'redux-saga/effects';
import { IEntityWithMessages } from '../../../services/HttpService';
import { uiActionCreators } from '../../ui';

function* activateProspectSaga(action: ActivateProspect) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IEntityWithMessages<IProspectApiResponse> = yield call(
    api.ActivateProspect,
    action.payload.prospectId
  );

  if (!response.error && response.value) {
    yield put(prospectActionCreators.updateProspectFulfilled(response.value));
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchActivateProspect() {
  yield takeEvery(ProspectsActionKeys.ACTIVATE_PROSPECT, activateProspectSaga);
}
